module.exports = __webpack_public_path__ + "img/com.electrolux.connectapphub.c0cf02a8.webp";